import { Box, Stack, SvgIconProps, Typography } from '@mui/material';

interface TimelineItemSectionProps extends React.ComponentProps<typeof Box> {
  children: React.ReactNode;
  title: string;
  Icon: React.ComponentType<SvgIconProps>;
  description?: React.ReactNode;
}

export const TimelineItemSection: React.FC<TimelineItemSectionProps> = ({
  children,
  title,
  Icon,
  description,
  ...props
}) => (
  <Box
    display="flex"
    flexDirection="column"
    p={1}
    flex={1}
    {...props}
    sx={{
      borderColor: 'divider',
      borderWidth: '1px',
      borderRadius: 1,
      borderStyle: 'solid',
      ':has(> :only-child)': {
        display: 'none',
      },
      ...props.sx,
    }}
  >
    <Stack direction="row" alignItems="center" gap={1} justifyContent="space-between">
      <Stack direction="row" alignItems="center" gap={0.5} justifyContent="flex-start">
        <Icon sx={{ fontSize: '1rem' }} />

        <Typography variant="body2" fontWeight="bold">
          {title}
        </Typography>
      </Stack>
      {description}
    </Stack>
    {children}
  </Box>
);
